import * as React from 'react';
import { MdCheckCircle } from 'react-icons/md';
import { timelineItem as style } from './style';
export const TimelineItem = (props) => {
    const css = style(props);
    return (React.createElement("div", { className: "event" },
        React.createElement("div", { className: `content ${props.extra ? 'extra-content' : ''}` }, props.children),
        React.createElement("div", { className: "extra" }, props.extra),
        React.createElement("div", { className: "tail" }),
        React.createElement("div", { className: `icon ${css}` }, props.icon)));
};
TimelineItem.defaultProps = {
    icon: React.createElement(MdCheckCircle, null),
    iconBgColor: '#d2d2d2',
};
//# sourceMappingURL=TimelineItem.js.map